// Copyright 2020 Greener Power Solutions                 //
// This file is part of the Greener Power Solutions,      //
// and may not be altered, copied, redistributed, or sold //
// without specific permission.                           //
import { ReactNode } from 'react';
import { useController } from 'react-hook-form';
import { Control, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { GridSize, TextFieldProps } from '@mui/material';
import TextField from '@mui/material/TextField';

export type RestrictedNumberFieldProps = {
  control?: Control<FieldValues>;
  label?: ReactNode;
  name?: string;
  required?: boolean;
  minValue?: number;
  maxValue?: number;
  helperText?: ReactNode;
  defaultValue?: number;
  gridSize?: boolean | GridSize | undefined;
  shrink?: boolean;
  endAdornment?: ReactNode;
  size?: 'small' | 'medium';
  useYupValidation?: boolean;
} & TextFieldProps;

export function RestrictedNumberField({
  label,
  name,
  control,
  required,
  minValue,
  maxValue,
  helperText,
  defaultValue,
  gridSize = 6,
  shrink = true,
  size = 'small',
  endAdornment,
  sx,
  useYupValidation = false,
  ...props
}: RestrictedNumberFieldProps) {
  const { t } = useTranslation();
  const {
    field: { onChange, ...inputProps },
    fieldState: { error },
  } = useController({
    name: name as string,
    control: control,
    rules: useYupValidation ? {} : { required: required, min: minValue, max: maxValue },
    defaultValue: defaultValue,
  });

  return (
    <Grid item xs={gridSize}>
      <TextField
        onChange={(e) => onChange(e.target.value ? parseInt(e.target.value) : null)}
        label={label}
        //@ts-expect-error overwritting
        name={name}
        type="number"
        required={required}
        InputLabelProps={{ shrink, required }}
        size={size}
        fullWidth
        InputProps={{ endAdornment }}
        helperText={
          useYupValidation
            ? (error && t(error.message as string)) || helperText
            : (error && minValue && maxValue && `Must be between ${minValue} and ${maxValue}`) || helperText
        }
        error={!!error}
        sx={sx}
        {...inputProps}
        value={inputProps.value ?? ''}
        {...props}
      />
    </Grid>
  );
}
